import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import formatDate from "../Utils/formatDate";
import { useDispatch, useSelector } from "react-redux";
import {
  addTests,
  addReferedBy,
  addDateTime,
} from "../Redux_Services/slices/testSlice";
import API_ENDPOINTS from "../service/api";
import ReportModal from "./ReportModa";
import whatsapp from "../assets/icon-whatsapp2.svg";
import { translations } from "../translation/translate";

const extractPdfUrl = (record = {}) =>
  record.combinedPdf ||
  record.combined_pdf ||
  record.reportLink ||
  record.report_link ||
  record.pdfUrl ||
  record.pdf_url ||
  record.ReportLink ||
  record.link ||
  record.url ||
  null;

export default function TestRecordModal({ isOpen, onClose }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSlowNetworkHint, setShowSlowNetworkHint] = useState(false);
  const [error, setError] = useState(null);
  const [pdfPreview, setPdfPreview] = useState({ open: false, url: null });
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareLinks, setShareLinks] = useState([]);
  const dispatch = useDispatch();
  const patientDetails = useSelector((state) => state.patientSlice.patientData);
  const token = useSelector((state) => state.authSlice.user.token);
  const userData = useSelector((state) => state.authSlice.user);
   const langData = useSelector((state) => state.langSlice.langData);

    // const getUnitAndRange = (testName, fieldName) => {
    //     for (const test of translations) {
    //         if (test.testFieldName.toLowerCase() === testName.toLowerCase()) {
    //             for (const field of test.fields) {
    //                 if (field.fieldName.toLowerCase() === fieldName.toLowerCase()) {
  //                     return {
  //                         unitAndRange: field.unitAndRange || "N/A",
  //                         bioReferenceInterval: field.bioReferenceInterval || "-",
  //                     };
  //                 }
  //                 if (field.subFields) {
  //                     for (const subField of field.subFields) {
  //                         if (subField.fieldName.toLowerCase() === fieldName.toLowerCase()) {
  //                             return {
  //                                 unitAndRange: subField.unitAndRange || "N/A",
  //                                 bioReferenceInterval: subField.bioReferenceInterval || "-",
  //                             };
  //                         }
  //                     }
  //                 }
  //             }
  //         }
  //     }

  //     // Default values if no match found
  //     return { unitAndRange: "N/A", bioReferenceInterval: "-" };
  // };

  // const transformTestData = (testData) => {
  //     const transformedData = [];

  //     try {
  //         Object.entries(testData).forEach(([testName, fields]) => {
  //             const processedFields = Object.entries(fields).map(([key, value]) => {
  //                 const { unitAndRange, bioReferenceInterval } = getUnitAndRange(testName, key);

  //                 return {
  //                     fieldId: key.toLowerCase().replace(/[^a-z0-9]/g, ""), // Clean field ID
  //                     fieldName: key,
  //                     value: value != null ? value.toString() : "-",
  //                     unitAndRange,
  //                     bioReferenceInterval,
  //                     subFields: [],
  //                 };
  //             });

  //             transformedData.push({
  //                 testFieldName: testName,
  //                 fields: processedFields,
  //             });
  //         });
  //     } catch (error) {
  //         console.error("Error transforming test data:", error);
  //     }

  //     return transformedData;
  // };

  const getMinimumLoaderMs = useCallback(() => {
    const connection = navigator?.connection || navigator?.mozConnection || navigator?.webkitConnection;
    const effectiveType = connection?.effectiveType;
    const downlink = connection?.downlink || 0;
    const saveData = connection?.saveData;

    if (saveData || effectiveType === "slow-2g" || effectiveType === "2g") return 3500;
    if (effectiveType === "3g" || (downlink > 0 && downlink < 1.5)) return 2500;
    return 1200;
  }, []);

  const fetchTestResults = useCallback(async () => {
    const patientId = patientDetails?.PatientID;
    const fetchStart = Date.now();

    if (!patientId) {
      setRecords([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const normalizeRecords = (payload = {}) => {
        let rawRecords = [];

        if (Array.isArray(payload?.data)) {
          rawRecords = payload.data;
        } else if (payload?.data) {
          rawRecords = [payload.data];
        } else if (Array.isArray(payload?.testResults)) {
          rawRecords = payload.testResults;
        }

        return rawRecords
          .map((item) => ({
            ...item,
            createdAt: item.createdAt || item.Created || item.created_at,
            ReportStatus: item.ReportStatus || item.status || "Available",
            TestData: item.TestData || item.testData || [],
            pdfUrl: extractPdfUrl(item),
          }))
          .sort(
            (a, b) =>
              new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
          );
      };

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      let fetchedRecords = [];

      // Prefer the new lab test result API (returns combinedPdf)
      const machineId = userData?.MachineID || userData?.MachineId;
      if (machineId) {
        try {
          const newApiUrl = `${API_ENDPOINTS.getLabTestResult}/${patientId}/${machineId}`;
          const response = await axios.get(newApiUrl, { headers });
          fetchedRecords = normalizeRecords(response.data);
        } catch (err) {
          console.error(
            "New lab test API failed, falling back to legacy API.",
            err
          );
        }
      }

      setRecords(fetchedRecords);
    } catch (error) {
      // console.error("Error fetching test results:", error.response ? error.response.data : error.message);
      setRecords([]);
      setError("Failed to fetch test results. Please try again later.");
    } finally {
      const elapsed = Date.now() - fetchStart;
      const minimumLoaderMs = getMinimumLoaderMs();
      if (elapsed < minimumLoaderMs) {
        await new Promise((resolve) =>
          setTimeout(resolve, minimumLoaderMs - elapsed)
        );
      }
      setLoading(false);
    }
  }, [getMinimumLoaderMs, patientDetails?.PatientID, token, userData?.MachineID, userData?.MachineId]);

  useEffect(() => {
    if (isOpen) {
      setRecords([]);
      setError(null);
      setPdfPreview({ open: false, url: null });
      setShareLinks([]);
      setLoading(true);
      fetchTestResults();
    }
  }, [isOpen, patientDetails?.PatientID, fetchTestResults]);

  useEffect(() => {
    let timerId;
    if (loading) {
      setShowSlowNetworkHint(false);
      timerId = setTimeout(() => {
        setShowSlowNetworkHint(true);
      }, 3500);
    } else {
      setShowSlowNetworkHint(false);
    }

    return () => {
      if (timerId) clearTimeout(timerId);
    };
  }, [loading]);
  // const handleContinue = (record) => {
  //     try {
  //         if (!record) {
  //             console.error("No record selected.");
  //             return;
  //         }
  //         console.log("Selected Record:", record);
  //         console.log("Original TestData: ", record.TestData);

  //         // const formattedTestData = record.TestData.map((item) => {
  //         //     const formattedFields = (item.tests || []).map((test) => ({
  //         //         fieldName: test.name,
  //         //         bioReferenceInterval: test.bioReferenceInterval,
  //         //         value: test.value,
  //         //         unitAndRange: test.unitAndRange,
  //         //         fieldId: test.testCode || "",
  //         //         subFields: []
  //         //     }));

  //         //     return {
  //         //         testFieldName: item.testFieldName,
  //         //         fields: formattedFields
  //         //     };
  //         // });

  //         // console.log("Formatted TestData: ", formattedTestData);

  //         //Here we have to filter the data and we have to remove the object whose fieldName start with the sample , eg "sampletyphoidigmigg"  , so can you do that

  //         dispatch(addTests(record.TestData));
  //         dispatch(addReferedBy(record.ReferredBy || ""));

  //         navigate("/tests/testId/report");
  //     } catch (error) {
  //         console.error("Error handling continue action:", error);
  //     }
  // };

  const handleContinue = (record) => {
    try {
      if (!record) {
        console.error("No record selected.");
        return;
      }
      // console.log("Selected Record:", record);
      // console.log("Original TestData: ", record.TestData);

      // Filter out objects with fields containing `fieldName` that starts with "sample"
      const filteredTestData = Array.isArray(record.TestData)
        ? record.TestData.map((item) => {
            const filteredFields = (item.fields || []).filter(
              (field) => !field.fieldName.startsWith("sample")
            );

            return {
              ...item,
              fields: filteredFields,
            };
          })
        : [];

      // console.log("Filtered TestData: ", filteredTestData);

      // Dispatching the filtered data
      dispatch(addTests(filteredTestData));
      dispatch(addDateTime(record.Created || record.createdAt || null));
      dispatch(addReferedBy(record.ReferredBy || ""));

      const pdfUrl = extractPdfUrl(record);
      if (pdfUrl) {
        localStorage.setItem("reportLink", pdfUrl);
      }

      setShareLinks(pdfUrl ? [{ Report: pdfUrl }] : []);
      setPdfPreview({ open: true, url: pdfUrl || null });
    } catch (error) {
      console.error("Error handling continue action:", error);
    }
  };

  const closePdfPreview = () => setPdfPreview({ open: false, url: null });
  const openShareModal = () => {
    if (!pdfPreview.url) return;
    if (!shareLinks.length) {
      setShareLinks([{ Report: pdfPreview.url }]);
    }
    setIsShareModalOpen(true);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white h-2/3 max-h-70 overflow-y-scroll rounded-lg shadow-lg w-full max-w-4xl">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4">
          <h2 className="text-xl font-semibold text-purple-500">
         {translations[langData].patientTestRecords}
          </h2>
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={onClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-6">
          {loading ? (
            <div className="text-center">
              <div>Loading reports...</div>
              {showSlowNetworkHint && (
                <div className="mt-2 text-xs text-gray-500">
                  Slow internet detected. Please wait, we are still fetching data.
                </div>
              )}
            </div>
          ) : error ? (
            <div className="text-red-500 text-center">
              No report found for this patient!
            </div>
          ) : records.length > 0 ? (
<table className="min-w-full table-auto">
  <thead>
    <tr className="bg-purple-100 text-purple-600 uppercase text-sm leading-normal">
      <th className="py-3 px-6 text-left"> {translations[langData].srNo}</th>
      <th className="py-3 px-6 text-left"> {translations[langData].dateAndTime}</th>
      <th className="py-3 px-6 text-left"> {translations[langData].referrdBY}</th>
      <th className="py-3 px-6 text-center"> {translations[langData].action}</th>
    </tr>
  </thead>

  <tbody className="text-gray-600 text-sm font-light">
    {records.map((record, index) => (
      <tr
        key={index}
        className="border-b border-gray-200 hover:bg-purple-50"
      >
        <td className="py-3 px-6 text-left">{index + 1}</td>

        <td className="py-3 px-6 text-left">
          {formatDate(record.createdAt)}
        </td>

        <td className="py-3 px-6 text-left">
          {record.ReferredBy || "-"}
        </td>

        <td className="py-3 px-6 text-center">
          <button
            className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 focus:outline-none"
            onClick={() => handleContinue(record)}
          >
             {translations[langData].viewReport}
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>

          ) : (
            <div className="text-center"> {translations[langData].noRecordAvailable}</div>
          )}
        </div>
      </div>

      {pdfPreview.open && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="bg-white w-11/12 h-5/6 rounded-lg shadow-2xl overflow-hidden flex flex-col">
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <h3 className="text-lg font-semibold text-purple-600">
              {translations[langData].reportPreview}
              </h3>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={closePdfPreview}
                aria-label="Close PDF preview"
              >
                ✕
              </button>
            </div>
            <div className="flex-1 bg-gray-100">
              {pdfPreview.url ? (
                <iframe
                  title="Report PDF"
                  src={pdfPreview.url}
                  className="w-full h-full"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-600">
                {translations[langData].noPdfAvailable}
                </div>
              )}
            </div>
            {pdfPreview.url && (
              <div className="flex items-center justify-between px-4 py-3 border-t gap-3 flex-wrap">
                <div className="flex items-center gap-3">
                  <a
                    href={pdfPreview.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white bg-purple-600 p-2 rounded font-semibold"
                  >
                    {translations[langData].openNewTab}
                  </a>
                  <button
                    // type="button"
                    onClick={openShareModal}
                    disabled={!pdfPreview.url}
                    className="flex items-center gap-2 px-3 py-2 bg-green-500  text-white rounded hover:bg-green-600"
                  >
                    <img src={whatsapp} alt="WhatsApp" className="w-5 h-5" />
                    {translations[langData].shareWithWhatasapp}
                  </button>
                </div>
                <button
                  className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                  onClick={closePdfPreview}
                >
                   {translations[langData].close}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <ReportModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        reportLink={shareLinks}
      />
    </div>
  );
}
